import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import { useLanguage } from '../../../i18n/LanguageContext';

const SearchBar = ({ searchQuery, onSearchChange, resultCount }) => {
  const { t } = useLanguage();
  
  return (
    <div className="search-bar-container w-full">
      <div className="relative">
        <Input
          type="search"
          placeholder={t('searchPlaceholder')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full pl-12 pr-4"
        />
        <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
          <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
        </div>
      </div>
      {searchQuery && (
        <p className="text-sm text-muted-foreground mt-2 px-1">
          {t('foundResults', { 
            count: resultCount, 
            unit: resultCount === 1 ? t('dish') : t('dishes') 
          })}
        </p>
      )}
    </div>
  );
};

export default SearchBar;